<div [id]="id" class="popover-generic scheduler align" [class.right]="position === 'right'" [class.left]="position === 'left'" [class.show]="showPopover">
    <div class="container-fluid">
        <a tabindex="0" [id]="id + 'BtnClosePopover'" class="float-end"
            (click)="hide()" (keydown.enter)="hide()" (keyup.space)="hide()" #closeBtn>
            <span class="fas fa-xl fa-xmark"></span>
        </a>
        <ng-content></ng-content>
    </div>
</div>